import { initAppOnAuthentication } from '../services/AppInitService';
import { AuthenticationResult } from '../services/AuthenticationService';

export const handleSuccessfulAuthentication = async (
	authResult: AuthenticationResult
): Promise<void> => {
	await initAppOnAuthentication(authResult);
};
